module.exports = __webpack_public_path__ + "img/stok_gudang.26ac35da.svg";